import { Group, Stack, Title, Text, Anchor, Box, type TitleProps } from '@mantine/core';
import {IconChevronLeft, IconInfoCircleFilled} from '@tabler/icons-react';
import { Link } from 'react-router';
import type { ReactNode } from 'react';

interface PageHeaderProps {
  title: ReactNode;
  breadcrumb?: { label: string; to?: string };
  description?: ReactNode;
  rightSection?: ReactNode;
  breadcrumbRight?: ReactNode;
  titleOrder?: TitleProps['order'];
}

export function PageHeader({
  title,
  breadcrumb,
  description,
  rightSection,
  breadcrumbRight,
  titleOrder = 1,
}: PageHeaderProps) {
  const breadcrumbNode = breadcrumb
    ? breadcrumb.to
      ? (
        <Anchor
          component={Link}
          to={breadcrumb.to}
          size="sm"
          style={{
            textDecoration: 'none',
            display: 'inline-flex',
            alignItems: 'center',
            gap: 8,
            color: 'var(--mantine-color-text)',
          }}
        >
          <Box
            style={{
              width: 24,
              height: 24,
              borderRadius: 6,
              background: 'var(--mantine-color-white)',
              border: '1px solid var(--mantine-color-vdzGray-2)',
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'center',
              flexShrink: 0,
            }}
          >
            <IconChevronLeft size={14} stroke={2} color="var(--mantine-color-vdzGray-8)" />
          </Box>
            <span style={{paddingTop: '3px'}}>{breadcrumb.label}</span>
        </Anchor>
      )
      : (
        <Text size="sm" fw={700} c="vdzGray.6" mb="-1rem">
          {breadcrumb.label}
        </Text>
      )
    : null;

  return (
    <Stack gap="md">
      {(breadcrumbNode || breadcrumbRight) && (
        <Group justify="space-between" align="center" wrap="nowrap">
          {breadcrumbNode ?? <span />}
          {breadcrumbRight && <Group>{breadcrumbRight}</Group>}
        </Group>
      )}
      <Group justify="space-between" align="flex-end" wrap="nowrap" gap="md">
        <Title order={titleOrder}>
          {title}
        </Title>
        {rightSection && <Group>{rightSection}</Group>}
      </Group>
      {description && (
        <Group gap={3} wrap="nowrap" align="center">
          <IconInfoCircleFilled size={14} color="var(--mantine-color-orange-6)" />
          <Text size="sm">
            {description}
          </Text>
        </Group>
      )}
    </Stack>
  );
}
